import { Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { IRowActions } from '../utils/types';

interface IProps<T> {
  record: T;
  actions: IRowActions<T>;
}

const RowActionsMenu = <T extends object>({ record, actions }: IProps<T>) => {
  const menuItems = actions.menuItems.map((item, index) => ({
    key: index,
    label: item.label,
    icon: item.icon,
    onClick: () => item.onClick(record),
  }));

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items: menuItems }}
      placement="bottomRight"
      overlayStyle={{ zIndex: 1000000 }}
    >
      <MoreOutlined
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
    </Dropdown>
  );
};

export default RowActionsMenu;
